<nav class="navbar d-flex" *ngIf="user$ | async; else notAuthenticated">
  <!-- 
  <button class="btn-material-icon d-inline-flex" (click)="onClickToggleToolbar()" >
    <i class="material-icons">
      menu
    </i>
  </button> 
  -->

  <ng-content *ngTemplateOutlet="partnerhubLogo"></ng-content>

  <!--
  <div ngbDropdown class="d-inline-block">
    <button class="btn-material-icon d-inline-flex p-0" ngbDropdownToggle>
      <i class="pi pi-bell icon-notifications"></i>

      <span *ngIf="numberOfUnreadNotifications > 0" class="badge badge-light ph-badge">{{
        numberOfUnreadNotifications
      }}</span>
    </button>

    <div ngbDropdownMenu class="text-center">
      <p
        ngbDropdownItem
        class="m-0 notification"
        [class.unread]="notification?.state?.name === 'UNREAD'"
        *ngFor="let notification of notifications"
      >
        <a routerLink="{{ notification.route }}" class="notification-text">{{ notification.text }}</a>
      </p>

      <p ngbDropdownItem class="m-0 notification" *ngIf="notifications.length === 0">
        There are no new notifications.
      </p>
    </div>
  </div>
  -->

  <!--
  <div class="alarm-divider h-100"></div>

-->
  <!-- <ng-content *ngTemplateOutlet="flag"> </ng-content> -->
  
  <div ngbDropdown class="d-inline-block logout">

    <button class="dropdown-toggle user-btn align-items-center justify-content-center" ngbDropdownToggle>
      <i class="pi pi-user"></i> {{ userName }}
    </button>

    <ul ngbDropdownMenu class="dropdown-menu  user-menu">
      <div class="menu-user-container">
        <!-- <li class="info"></li> -->
        <!-- <li class="line"> </li> -->
        <li class="info">{{'generic.changeLanguage' | translate}}</li>
        <li *ngFor="let locale of availableTranslationLocales"><a class="pointer" href="javascript:void(0);"
            ngbDropdownItem [class.active]="currentTranslationLocale === locale.locale"
            (click)="changeLanguage(locale)">
            <i class="pi pi-globe"></i>
            {{ locale.key }}
          </a>
        </li>
        <li class="line"> </li>
        <li class="info">{{'generic.optionAcount' | translate}}</li>

        <li>
          <a ngbDropdownItem href="javascript:void(0);" (click)="changePassword()">
            <i class="pi pi-lock"></i>
            {{'authentication.changePassword' | translate}}
          </a>
        </li>

        <li>
          <a ngbDropdownItem href="javascript:void(0);" (click)="onClickLogout()">
            <i class="pi pi-power-off"></i>
            {{'auth.logout' | translate}}
          </a>
        </li>
      </div>
    </ul>

  </div>
</nav>

<ng-template #notAuthenticated>
  <nav class="navbar">
    <ng-content *ngTemplateOutlet="partnerhubLogo"></ng-content>

    <!--<ng-content *ngTemplateOutlet="flag"></ng-content>-->
  </nav>
</ng-template>

<ng-template #partnerhubLogo>
  <a class="navbar-brand mr-auto" routerLink="/">
    <img class="vivo-logo-height ml-3 mr-3" src="../assets/images/toolbar/logo_vivo@2x.png" *ngIf="true" />
    <img class="logo-height" src="../assets/images/toolbar/logo_prmportal@2x.png" />
  </a>
</ng-template>

<!-- 
<ng-template #flag>
  <div ngbDropdown class="d-inline-bock mr-3">
    <button class="btn-material-icon d-inline-flex p-0" ngbDropdownToggle>
      <i class="pi pi-globe icon-translate"></i>
    </button>

    <div ngbDropdownMenu class="dropdown-menu-sm">
      <a
        class="pointer language"
        href="javascript:void(0);"
        ngbDropdownItem
        [class.active]="currentTranslationLocale === locale.locale"
        (click)="changeLanguage(locale)"
        *ngFor="let locale of availableTranslationLocales"
      >
        {{ locale.key }}
      </a>
    </div>
  </div>
</ng-template> -->